import axios from "axios";

let csrfToken = null;

const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    "http://localhost:5000",

  withCredentials: true,
});



/* =========================================
   FETCH CSRF TOKEN
========================================= */

export const fetchCsrfToken = async () => {

  const res = await api.get(
    "/api/csrf-token"
  );

  csrfToken = res.data.csrfToken;

  return csrfToken;
};



/* =========================================
   REQUEST INTERCEPTOR
========================================= */

api.interceptors.request.use(
  (config) => {

    if (csrfToken) {
      config.headers["X-CSRF-Token"] =
        csrfToken;
    }

    return config;
  }
);



/* =========================================
   REFRESH TOKEN QUEUE
========================================= */

let isRefreshing = false;

let failedQueue = [];

const processQueue = (
  error = null
) => {

  failedQueue.forEach((promise) => {

    if (error) {
      promise.reject(error);
    } else {
      promise.resolve();
    }

  });

  failedQueue = [];
};



/* =========================================
   RESPONSE INTERCEPTOR
========================================= */

api.interceptors.response.use(

  (response) => response,

  async (error) => {

    const original = error.config;

    //console.log(
    //   "INTERCEPTOR ERROR"
    // );

    //console.log(
    //   error.response?.status
    // );

    //console.log(
    //   error.response?.data
    // );



    /* =========================================
       REFRESH REQUEST FAILED
    ========================================= */

    if (
      original?.url?.includes(
        "/api/auth/refresh"
      )
    ) {

      //console.log(
      //   "REFRESH TOKEN FAILED"
      // );

      window.dispatchEvent(
        new CustomEvent(
          "session-expired",
          {
            detail: {
              message:
                "You were signed out automatically for security reasons. Please login again to continue.",
            },
          }
        )
      );

      return Promise.reject(error);
    }



    /* =========================================
       HANDLE CSRF TOKEN ERRORS
    ========================================= */

    if (
      error.response?.status === 403 &&
      error.response?.data?.message
        ?.toLowerCase()
        .includes("csrf") &&
      !original._csrfRetry
    ) {

      //console.log(
      //   "CSRF TOKEN INVALID"
      // );

      original._csrfRetry = true;

      try {

        await fetchCsrfToken();

        return api(original);

      } catch (err) {

        return Promise.reject(err);
      }
    }



    /* =========================================
       HANDLE 401 ERRORS
    ========================================= */

    if (
      error.response?.status === 401
    ) {

      // //console.log(
      //   "401 DETECTED"
      // );

      const message =
        error.response?.data
          ?.message || "";



      /* =========================================
         DON'T REFRESH ON LOGIN PAGE
      ========================================= */

      const isPublicPage =
        window.location.pathname === "/";



      /* =========================================
         ONLY SKIP ACTUAL REFRESH API
      ========================================= */

      const isRefreshApi =
        original?.url?.includes(
          "/api/auth/refresh"
        );



      /* =========================================
         SHOULD TRY REFRESH
      ========================================= */

      const shouldTryRefresh =
        !isPublicPage &&
        !isRefreshApi &&
        (
          error.response?.data
            ?.expired ||

          message.includes(
            "No token provided"
          ) ||

          message.includes(
            "Invalid token"
          )
        ) &&
        !original._retry;



      if (shouldTryRefresh) {

        //console.log(
        //   "TRYING AUTO REFRESH"
        // );



        /* =========================================
           WAIT IF REFRESH ALREADY RUNNING
        ========================================= */

        if (isRefreshing) {

          return new Promise(
            (
              resolve,
              reject
            ) => {

              failedQueue.push({
                resolve: () =>
                  resolve(
                    api(original)
                  ),
                reject,
              });

            }
          );
        }



        original._retry = true;

        isRefreshing = true;



        try {

          /* =========================================
             REFRESH TOKEN
          ========================================= */

          await api.post(
            "/api/auth/refresh"
          );

          //console.log(
          //   "REFRESH SUCCESS"
          // );



          /* =========================================
             RETRY WAITING REQUESTS
          ========================================= */

          processQueue();



          /* =========================================
             WAIT FOR COOKIE UPDATE
          ========================================= */

          await new Promise(
            (resolve) =>
              setTimeout(
                resolve,
                100
              )
          );



          /* =========================================
             RETRY ORIGINAL REQUEST
          ========================================= */

          return api(original);

        } catch (err) {

          //console.log(
          //   "REFRESH FAILED"
          // );

          processQueue(err);



          window.dispatchEvent(
            new CustomEvent(
              "session-expired",
              {
                detail: {
                  message:
                    "Your session expired. Please login again to continue.",
                },
              }
            )
          );

          return Promise.reject(err);

        } finally {

          isRefreshing = false;
        }
      }
    }



    return Promise.reject(error);
  }
);



/* =========================================
   AUTH APIs
========================================= */

export const sendOtp = (
  email
) =>
  api.post(
    "/api/auth/send-otp",
    { email }
  );

export const verifyOtp = (
  email,
  otp
) =>
  api.post(
    "/api/auth/verify-otp",
    {
      email,
      otp,
    }
  );

export const googleLogin = (
  token
) =>
  api.post(
    "/api/auth/google-login",
    { token }
  );

export const getMe = () =>
  api.get("/api/auth/me");

export const logout = () =>
  api.post("/api/auth/logout");



export default api;